import React, { PropTypes } from 'react';
import Page from 'components/Page';
import Pattern from 'components/Pattern';
import Content from 'components/Content';
import Column from 'components/Content/Column';
import PureComponent from 'components/PureComponent';
import Socials from 'components/Socials';
// import Next from 'components/Next';
import Bottle from 'components/Bottle';
// import CodeButton from 'components/CodeButton';
import BuyButton from 'components/BuyButton';
import DocumentTitle from 'react-document-title';
import checkMobile from 'utils/checkMobile';

import baikal from './baikal.png';
import baikalShadow from './baikal-shadow.png';
import baikal_mobile from './baikal_mobile.png';
import i430m from './i430m.svg';
import i1_5km from './i1.5km.svg';
// import rst_iso from './rst-iso.png';
// import fssc from './fssc.png';

const MAP_LINK =
  "https://www.google.ru/maps/place/51%C2%B049'07.0%22N+104%C2%B052'32.0%22E/@51.8186026,104.8755556,8z/data=!4m2!3m1!1s0x0:0x0";

class Source extends PureComponent {
  static contextTypes = {
    deviceType: PropTypes.string
  };

  render() {
    require('./Source.styl');
    const { deviceType } = this.context;
    const isMobile = checkMobile(deviceType, this.props.viewport);

    const pageProps = {
      style: {
        backgroundImage: isMobile ? '' : `url(${this.props.backgroundImage[0]})`
      }
    };

    return (
      <Page {...pageProps}>
        <DocumentTitle title="Место добычи — Глубинная байкальская вода BAIKAL430" />

        {!isMobile && <Pattern left="70%" />}
        <Content
          style={{ zIndex: 1000 }}
          className={isMobile ? 'Content Source__content' : 'Content'}
        >
          <Column
            style={
              isMobile
                ? { paddingBottom: 160, textAlign: 'left' }
                : { paddingBottom: 0, marginBottom: -30, textAlign: 'left' }
            }
            className={
              isMobile
                ? 'Content__column Source__column-mobile'
                : 'Content__column'
            }
          >
            <div
              className={`Source__fact ${
                isMobile ? 'Source__fact-mobile' : ''
              }`}
            >
              <p>
                ТОЧКА ЗАБОРА
                <br />
                ВОДЫ НАХОДИТСЯ
                <br />
                НА ГЛУБИНЕ
              </p>
              <img src={i430m} width="85" height="55" alt="430м" />
            </div>
            <div
              className={`Source__fact ${
                isMobile ? 'Source__fact-mobile' : ''
              }`}
            >
              <p>
                ПРОТЯЖЕННОСТЬ
                <br />
                СИСТЕМЫ ЗАБОРА
                <br />
                ВОДЫ БОЛЕЕ
              </p>
              <img src={i1_5km} width="79" height="55" alt="1,5км" />
            </div>

            {isMobile && (
              <div
                className="Source__baikal-mobile"
                style={{
                  position: 'absolute'
                }}
              >
                <a href={MAP_LINK} target="_blank" />
                <img src={baikal_mobile} width="300" height="217" />
              </div>
            )}

            {/* {!isMobile && (
              <CodeButton
                style={{
                  marginTop: 40
                }}
              />
            )} */}

            {/* {!isMobile && (
              <BuyButton
                style={{
                  marginTop: 20
                }}
              />
            )} */}
          </Column>

          {isMobile && (
            <Column
              className="Content__column--bottle"
              style={{
                backgroundImage: `url(${this.props.backgroundImage[0]})`
              }}
            >
              <Bottle cover={this.props.backgroundImage[1]} />
            </Column>
          )}

          <Column style={isMobile ? {} : { paddingBottom: 70 }}>
            {/* {isMobile && (
              <CodeButton
                style={{
                  marginBottom: 20
                }}
              />
            )} */}

            {/* {isMobile && (
              <BuyButton
                style={{
                  marginBottom: 40
                }}
              />
            )} */}

            <h2>Особый слой сверхчистой воды</h2>
            <p>
              Изучая Байкал, ученые установили, что на глубине между 400 и 500
              метрами содержится реликтовая чистейшая вода с особыми свойствами.
              Этот слой не перемешивается с другими, отличается постоянством
              состава и насыщенностью кислородом. Вода сверхлегкой минерализации
              BAIKAL430 добывается из этого слоя на глубине 430 метров.
            </p>
          </Column>
        </Content>

        {!isMobile && (
          <div className="Source__baikal">
            <a href={MAP_LINK} target="_blank" />
            <img src={baikal} width="1025" height="630" />
            <img src={baikalShadow} width="1025" height="630" />
          </div>
        )}

        <div className="Page__socials">
          <Socials light />
        </div>

        {/* {isMobile && (
          <Next to="/journey" label="Выиграй путешествие на&nbsp;Байкал" />
        )} */}
      </Page>
    );
  }
}

export default Source;



// WEBPACK FOOTER //
// ./src/pages/Source/Source.js